var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"expand":"","nav":""}},[_c('div'),_vm._l((_vm.computedItems),function(item,i){return [_c('left-navigation-menu-list-item',{key:("item-" + i),attrs:{"item":item}})]}),_c('div')],2)}
var staticRenderFns = []

export { render, staticRenderFns }